'use client';

import _slicedToArray from "/var/lib/jenkins/workspace/netstore-ui-frontend-triggered-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/var/lib/jenkins/workspace/netstore-ui-frontend-triggered-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/var/lib/jenkins/workspace/netstore-ui-frontend-triggered-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';

/**
 * @internal
 */
var SkeletonThemeContext = React.createContext({});

/* eslint-disable react/no-array-index-key */
var defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function styleOptionsToCssProperties(_ref) {
  var baseColor = _ref.baseColor,
    highlightColor = _ref.highlightColor,
    width = _ref.width,
    height = _ref.height,
    borderRadius = _ref.borderRadius,
    circle = _ref.circle,
    direction = _ref.direction,
    duration = _ref.duration,
    _ref$enableAnimation = _ref.enableAnimation,
    enableAnimation = _ref$enableAnimation === void 0 ? defaultEnableAnimation : _ref$enableAnimation;
  var style = {};
  if (direction === 'rtl') style['--animation-direction'] = 'reverse';
  if (typeof duration === 'number') style['--animation-duration'] = "".concat(duration, "s");
  if (!enableAnimation) style['--pseudo-element-display'] = 'none';
  if (typeof width === 'string' || typeof width === 'number') style.width = width;
  if (typeof height === 'string' || typeof height === 'number') style.height = height;
  if (typeof borderRadius === 'string' || typeof borderRadius === 'number') style.borderRadius = borderRadius;
  if (circle) style.borderRadius = '50%';
  if (typeof baseColor !== 'undefined') style['--base-color'] = baseColor;
  if (typeof highlightColor !== 'undefined') style['--highlight-color'] = highlightColor;
  return style;
}
function Skeleton(_ref2) {
  var _ref2$count = _ref2.count,
    count = _ref2$count === void 0 ? 1 : _ref2$count,
    Wrapper = _ref2.wrapper,
    customClassName = _ref2.className,
    containerClassName = _ref2.containerClassName,
    containerTestId = _ref2.containerTestId,
    _ref2$circle = _ref2.circle,
    circle = _ref2$circle === void 0 ? false : _ref2$circle,
    styleProp = _ref2.style,
    originalPropsStyleOptions = _objectWithoutProperties(_ref2, ["count", "wrapper", "className", "containerClassName", "containerTestId", "circle", "style"]);
  var _a, _b, _c;
  var contextStyleOptions = React.useContext(SkeletonThemeContext);
  var propsStyleOptions = _objectSpread({}, originalPropsStyleOptions);
  // DO NOT overwrite style options from the context if `propsStyleOptions`
  // has properties explicity set to undefined
  for (var _i = 0, _Object$entries = Object.entries(originalPropsStyleOptions); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (typeof value === 'undefined') {
      delete propsStyleOptions[key];
    }
  }
  // Props take priority over context
  var styleOptions = _objectSpread({}, contextStyleOptions, propsStyleOptions, {
    circle: circle
  });
  // `styleProp` has the least priority out of everything
  var style = _objectSpread({}, styleProp, styleOptionsToCssProperties(styleOptions));
  var className = 'react-loading-skeleton';
  if (customClassName) className += " ".concat(customClassName);
  var inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
  var elements = [];
  var countCeil = Math.ceil(count);
  for (var i = 0; i < countCeil; i++) {
    var thisStyle = style;
    if (countCeil > count && i === countCeil - 1) {
      // count is not an integer and we've reached the last iteration of
      // the loop, so add a "fractional" skeleton.
      //
      // For example, if count is 3.5, we've already added 3 full
      // skeletons, so now we add one more skeleton that is 0.5 times the
      // original width.
      var width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : '100%'; // 100% is the default since that's what's in the CSS
      var fractionalPart = count % 1;
      var fractionalWidth = typeof width === 'number' ? width * fractionalPart : "calc(".concat(width, " * ").concat(fractionalPart, ")");
      thisStyle = _objectSpread({}, thisStyle, {
        width: fractionalWidth
      });
    }
    var skeletonSpan = React.createElement("span", {
      className: className,
      style: thisStyle,
      key: i
    }, "\u200C");
    if (inline) {
      elements.push(skeletonSpan);
    } else {
      // Without the <br />, the skeleton lines will all run together if
      // `width` is specified
      elements.push(React.createElement(React.Fragment, {
        key: i
      }, skeletonSpan, React.createElement("br", null)));
    }
  }
  return React.createElement("span", {
    className: containerClassName,
    "data-testid": containerTestId,
    "aria-live": "polite",
    "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : defaultEnableAnimation
  }, Wrapper ? elements.map(function (el, i) {
    return React.createElement(Wrapper, {
      key: i
    }, el);
  }) : elements);
}
function SkeletonTheme(_ref3) {
  var children = _ref3.children,
    styleOptions = _objectWithoutProperties(_ref3, ["children"]);
  return React.createElement(SkeletonThemeContext.Provider, {
    value: styleOptions
  }, children);
}
export { SkeletonTheme, Skeleton as default };